import React, { useId } from 'react';
import PropTypes from 'prop-types';

function Checkbox({ label, checked, className, disabled = false, onChange }) {
  const id = useId();

  return (
    <label htmlFor={id} className={'dealer-checkbox' + (className ? ' ' + className : '')} disabled={disabled} onChange={onChange}>
      <input id={id} type="checkbox" className="sr-only" checked={checked} onChange={onChange} />
      <span>{label}</span>
    </label>
  );
}

Checkbox.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

export default Checkbox;
